import React from 'react';
import { IconProps } from '../IconProps';

export interface DeprecatedSettingIconProps extends IconProps {
	color?: string;
}

export const DeprecatedSettingIcon: React.FC<DeprecatedSettingIconProps> = ({
	width = 20,
	height = 20,
	color = '#767676',
	className,
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width={width}
			height={height}
			viewBox="0 0 20 20"
			fill="none"
			className={className}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10 13.75C9.82741 13.75 9.6875 13.8899 9.6875 14.0625C9.6875 14.2351 9.82741 14.375 10 14.375C10.1726 14.375 10.3125 14.2351 10.3125 14.0625C10.3125 13.8899 10.1726 13.75 10 13.75Z"
				fill={color}
				stroke={color}
				strokeWidth="1.25"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M10 11.25V4.375"
				stroke={color}
				strokeWidth="1.25"
				strokeLinecap="round"
			/>
			<path
				d="M10 19.375C15.1777 19.375 19.375 15.1777 19.375 10C19.375 4.82233 15.1777 0.625 10 0.625C4.82233 0.625 0.625 4.82233 0.625 10C0.625 15.1777 4.82233 19.375 10 19.375Z"
				stroke={color}
				strokeWidth="1.25"
			/>
		</svg>
	);
};
